export const FETCH_DAY_WEIGHTS = 'FETCH_DAY_WEIGHTS';
export const FETCH_DAY_WEIGHTS_FETCHING = 'FETCH_DAY_WEIGHTS_FETCHING';
export const FETCH_DAY_WEIGHTS_SUCCESS = 'FETCH_DAY_WEIGHTS_SUCCESS';
export const FETCH_DAY_WEIGHTS_FAIL = 'FETCH_DAY_WEIGHTS_FAIL';

export const FETCH_FIRST_WEIGHT = 'FETCH_FIRST_WEIGHT';
export const FETCH_FIRST_WEIGHT_SUCCESS = 'FETCH_FIRST_WEIGHT_SUCCESS';

export const FETCH_LATEST_WEIGHT = 'FETCH_LATEST_WEIGHT';
export const FETCH_LATEST_WEIGHT_FETCHING = 'FETCH_LATEST_WEIGHT_FETCHING';
export const FETCH_LATEST_WEIGHT_SUCCESS = 'FETCH_LATEST_WEIGHT_SUCCESS';
export const FETCH_LATEST_WEIGHT_FAIL = 'FETCH_LATEST_WEIGHT_FAIL';

export const DELETE_USER_WEIGHT_GOAL = 'DELETE_USER_WEIGHT_GOAL';
export const DELETING_USER_WEIGHT_GOAL = 'DELETING_USER_WEIGHT_GOAL';
export const DELETE_USER_WEIGHT_GOAL_SUCCESS = 'DELETE_USER_WEIGHT_GOAL_SUCCESS';
export const DELETE_USER_WEIGHT_GOAL_FAIL = 'DELETE_USER_WEIGHT_GOAL_FAIL';
export const UPDATE_USER_GOAL = 'UPDATE_USER_GOAL';
export const UPDATE_USER_GOAL_START = 'UPDATE_USER_GOAL_START';
export const UPDATE_USER_GOAL_SUCCESS = 'UPDATE_USER_GOAL_SUCCESS';
export const UPDATE_USER_GOAL_FAIL = 'UPDATE_USER_GOAL_FAIL';
export const ADD_USER_WEIGHT = 'ADD_USER_WEIGHT';
export const ADD_USER_WEIGHT_START = 'ADD_USER_WEIGHT_START';
export const ADD_USER_WEIGHT_SUCCESS = 'ADD_USER_WEIGHT_SUCCESS';
export const ADD_USER_WEIGHT_FAIL = 'ADD_USER_WEIGHT_FAIL';

export const SET_CURRENT_WEIGHT_TAB = 'SET_CURRENT_WEIGHT_TAB';
export const FETCH_MONTHLY_WEIGHTS = 'FETCH_MONTHLY_WEIGHTS';
export const FETCH_MONTHLY_WEIGHTS_FETCHING = 'FETCH_MONTHLY_WEIGHTS_FETCHING';
export const FETCH_MONTHLY_WEIGHTS_FAIL = 'FETCH_MONTHLY_WEIGHTS_FAIL';
export const FETCH_MONTHLY_WEIGHTS_SUCCESS = 'FETCH_MONTHLY_WEIGHTS_SUCCESS';
export const FETCH_52_WEEKS_WEIGHTS = 'FETCH_52_WEEKS_WEIGHTS';
export const FETCH_52_WEEKS_WEIGHTS_FETCHING = 'FETCH_52_WEEKS_WEIGHTS_FETCHING';
export const FETCH_52_WEEKS_WEIGHTS_FAIL = 'FETCH_52_WEEKS_WEIGHTS_FAIL';
export const FETCH_52_WEEKS_WEIGHTS_SUCCESS = 'FETCH_52_WEEKS_WEIGHTS_SUCCESS';
export const FETCH_52_WEEKS_WEIGHTS_REPORT = 'FETCH_52_WEEKS_WEIGHTS_REPORT';
export const FETCH_52_WEEKS_WEIGHTS_REPORT_FETCHING = 'FETCH_52_WEEKS_WEIGHTS_REPORT_FETCHING';
export const FETCH_52_WEEKS_WEIGHTS_REPORT_FAIL = 'FETCH_52_WEEKS_WEIGHTS_REPORT_FAIL';
export const FETCH_52_WEEKS_WEIGHTS_REPORT_SUCCESS = 'FETCH_52_WEEKS_WEIGHTS_REPORT_SUCCESS';
export const FETCH_MULTIPLE_DAYS_WEIGHTS = 'FETCH_MULTIPLE_DAYS_WEIGHTS';
export const FETCH_MULTIPLE_DAYS_WEIGHTS_FETCHING = 'FETCH_MULTIPLE_DAYS_WEIGHTS_FETCHING';
export const FETCH_MULTIPLE_DAYS_WEIGHTS_SUCCESS = 'FETCH_MULTIPLE_DAYS_WEIGHTS_SUCCESS';
export const FETCH_MULTIPLE_DAYS_WEIGHTS_FAIL = 'FETCH_MULTIPLE_DAYS_WEIGHTS_FAIL';

export const DELETE_USER_WEIGHT = 'DELETE_USER_WEIGHT';
export const DELETE_USER_WEIGHT_FETCHING = 'DELETE_USER_WEIGHT_FETCHING';
export const DELETE_USER_WEIGHT_SUCCESS = 'DELETE_USER_WEIGHT_SUCCESS';
export const DELETE_USER_WEIGHT_FAIL = 'DELETE_USER_WEIGHT_FAIL';

export const SET_CURRENT_PAGE_DATE = 'SET_CURRENT_PAGE_DATE';

export const SELECT_DATA_FOR_CHART = 'SELECT_DATA_FOR_CHART';

export const CLEAN_UP_DATA = 'CLEAN_UP_WEIGHT_DATA';
export const TOGGLE_WEIGHT_OVERLAY = 'TOGGLE_WEIGHT_OVERLAY';

export const FETCH_MULTIPLE_DAILY_WEIGHTS = 'FETCH_MULTIPLE_DAILY_WEIGHTS';
export const FETCH_MULTIPLE_DAILY_WEIGHTS_FETCHING = 'FETCH_MULTIPLE_DAILY_WEIGHTS_FETCHING';
export const FETCH_MULTIPLE_DAILY_WEIGHTS_SUCCESS = 'FETCH_MULTIPLE_DAILY_WEIGHTS_SUCCESS';
export const FETCH_MULTIPLE_DAILY_WEIGHTS_FAIL = 'FETCH_MULTIPLE_DAILY_WEIGHTS_FAIL';

export const FETCH_WEIGHT_GAIN_GOALS = 'FETCH_WEIGHT_GAIN_GOALS';
export const FETCH_WEIGHT_GAIN_GOALS_FETCHING = 'FETCH_WEIGHT_GAIN_GOALS_FETCHING';
export const FETCH_WEIGHT_GAIN_GOALS_SUCCESS = 'FETCH_WEIGHT_GAIN_GOALS_SUCCESS';
export const FETCH_WEIGHT_GAIN_GOALS_FAIL = 'FETCH_WEIGHT_GAIN_GOALS_FAIL';
